export default __webpack_public_path__ + "static/media/q28_step6.da643908.png";